import React from 'react';
import { ReactComponent as UpArrow } from '../../assets/images/icons/up-arrow.svg';

export default function UpArrowIcon(props) {
  return (
    <UpArrow className={`icon ${props.className}`} />
  );
}
